

<nav style="background-color: rgb(0, 128, 255);">
	<div class="container">
		<div class="row">
			<div class="text-center col-sm-12 col-md-2 col-lg-2 col-xl-2">
				<img (mouseenter)="hoversound()" (click)="clicksound()" routerLink="/accueilemploye" src="../assets/img/homeicon.png" width="30" height="30" />
			</div>
			<div class="text-center text-left col-sm-12 col-md-5 col-lg-5 col-xl-5">
				<h4>
      
					<button (mouseenter)="hoversound()" (click)="clicksound()" type="button" routerLink="/chercheremploye" class="btn btn-outline-light btn-sm">Chercher</button> &nbsp;
      
					<button (mouseenter)="hoversound()" (click)="clicksound()" type="button" routerLink="/consulteremploye" class="btn btn-light btn-sm">Consulter</button> &nbsp;
				</h4>
			</div>
			<div class=" text-center col-sm-12 col-md-3 col-lg-3 col-xl-3">
				<h4 id="connectnomm"> 
					<button (click)="deconnecter()"  (click)="clicksound()" (mouseenter)="hoversound()" type="button" class="btn btn-outline-dark btn-sm">Déconnecter</button> &nbsp;
				</h4>
			</div>
			<div class="text-center col-sm-12 col-md-2 col-lg-2 col-xl-2">
				<h4>
					<a (mouseenter)="hoversound()" (click)="clicksound()" href="mailto: moahmeddhia.jebali@isticbc.org"  class="btn btn-outline-warning btn-sm">Contacter</a> &nbsp;
      
					<input (mouseenter)="hoversound()" (click)="clicksound()" (click)="aproposderun()" type="button" name="aproposde" id="aproposde" class="btn btn-outline-warning btn-sm" value="À propos de"> &nbsp;
					</h4>
				</div>
			</div>
		</div>
	</nav>
	<br>
		<div class="container">
			<div class="row">
				<div class="text-center col-sm-12 col-md-8 col-lg-8 col-xl-6">
					<h1 style="font-size:50px;">Gestion des Employés</h1>
				</div>
				<div class="text-center col-sm-12 col-md-8 col-lg-8 col-xl-4">
					<br>
						<h3>Presentation liste des employés</h3>
					</div>
					<div class="text-center col-sm-12 col-md-8 col-lg-8 col-xl-2">
						<img src="../assets/img/consultericon.png"  width="60" height="50" />
					</div>
				</div>
			</div>
			<br>

			<div class="container">
				<table class="table">
					<thead class="thead-dark">
					  <tr>
						<th scope="col">Photo</th>
						<th scope="col">EID</th>
						<th scope="col">CIN</th>
						<th scope="col">Prénom</th>
						<th scope="col">Nom</th>
						<th scope="col">Ville</th>
						<th scope="col">Tel</th>
						<th scope="col">Email</th>
						<th scope="col">Salaire</th>
					  </tr>
					</thead>
					<tbody id="table">
					  <tr>
						<td> </td>
						<td> </td>
						<td> </td>
						<td> </td>
						<td> </td>
						<td> </td>
						<td> </td>
						<td> </td>
						<td> </td>
					  </tr>
				
					</tbody>
				  </table>
				
				  <br>
				  <hr>
				
				</div>